export default "__VITE_ASSET__3PcvnBvn__"